<div class="daily-rewards" *ngIf="currentDay() !== undefined">
  <h2>Daily Rewards</h2>
  <div class="rewards-container">
    <div
      *ngFor="let reward of rewards"
      class="reward-box"
      [class.active]="reward.day === currentDay()"
      [class.completed]="reward.day < currentDay()"
      [class.future]="reward.day > currentDay()"
    >
      <span class="reward-icon"><img src="../../../../assets/images/rewards.png" alt="Rewards"></span>
      <p class="day-text">Day {{ reward.day }}</p>
      <p class="points-text">+{{ reward.points }} pts</p>
      <span class="reward-icon-crown" *ngIf="reward.day < currentDay()">
        <img src="../../../../assets/images/done.png" alt="Done">
      </span>
      <span class="reward-icon-crown" *ngIf="reward.day === lastDay">
        <img src="../../../../assets/images/crown.png" alt="Crown">
      </span>
    </div>
  </div>
</div>
